module.exports = __webpack_public_path__ + "static/media/napoli sauce.7b06fd1a.png";